import axios from "@/utils/axiosHelper";

// 初始化用户数据
export const initUserinfo = params => {
    return axios(
        { url: "/snail/cruise/index", method: "GET", params },
        { interceptResultCode: false }
    );
};

// 里程碑数据
export const getMilestone = params => {
    return axios(
        { url: "/snail/cruise/milestone", method: "GET", params },
        { interceptResultCode: false }
    );
};

// 第二期活动接口
// 初始化第二期数据
export const initThirdTravelData = params => {
    return axios(
        { url: "/snail/cruise/init", method: "GET", params },
        { interceptResultCode: false }
    );
};

// 提交答题数据
export const answer = params => {
    return axios(
        { url: "/snail/cruise/make/store", method: "post", params },
        { interceptResultCode: false }
    );
};

// 获取分享奖励
export const getShareReward = params => {
    return axios(
        { url: "/snail/cruise/make/share", method: "GET", params },
        { interceptResultCode: false }
    );
};

// 获取答题奖励
export const getAnswerReward = params => {
    return axios(
        { url: "/snail/cruise/make/reward", method: "GET", params },
        { interceptResultCode: false }
    );
};

// 获取里程碑和印花奖励
export const getFlowerReward = params => {
    return axios(
        { url: "/snail/cruise/milestone/reward", method: "post", params },
        { interceptResultCode: false }
    );
};

// 获取任务奖励
export const getMissionReward = params => {
    return axios(
        { url: "/snail/cruise/printing/store", method: "post", params },
        { interceptResultCode: false }
    );
};



// WEBPACK FOOTER //
// ./src/pages/snail/riverMountain-3/api.js